export default "__VITE_ASSET__02957e4d__"